import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';

import createHistory from 'history/createBrowserHistory';

const history = createHistory();
const composeEnhancers = typeof window === 'object' 
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ 
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

const middleware = [thunk, routerMiddleware(history)];

const enhancer = composeEnhancers(
  applyMiddleware(...middleware)
);

export default (initialState) => {
  return createStore(
    rootReducer,
    enhancer
  )
};



/** WEBPACK FOOTER **
 ** ./src/store/configure-store.js
 **/